export default class SwitchUtils {
  //Allows to use switch statement exhaustive checks (even at compile time)
  //from https://2ality.com/2020/01/typescript-enums.html#exhaustiveness-checks-for-literal-enums
  public static throwUnsupportedValue(value: never): never {
    throw new TypeError("Unsupported value: " + value);
  }
}
